module.exports = "/_next/static/images/99f66323ae5b697ec4150f4f31858af9-perks-lg-2x.jpg.webp";